import { render, staticRenderFns } from "./PaymentRequestTabLegalInfo.vue?vue&type=template&id=42b8f606"
import script from "./PaymentRequestTabLegalInfo.vue?vue&type=script&lang=js"
export * from "./PaymentRequestTabLegalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports